import { PersistConfig, PersistedState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { AccountSlice } from '../types';

const isAccountSlice = (
  state: unknown,
): state is AccountSlice & PersistedState =>
  typeof state === 'object' && state !== null;

export const accountPersistConfig: PersistConfig<AccountSlice> = {
  key: 'account',
  storage,
  migrate: async state => {
    if (isAccountSlice(state)) {
      return Object.fromEntries(
        Object.entries(state).map(([key, value]) => {
          if ('isWorkerAuthorized' in value) {
            value.isWorkerAuthorized = false;
          }

          return [key, value];
        }),
      ) as AccountSlice & PersistedState;
    }

    return state;
  },
};
